import { render, staticRenderFns } from "./ProductionWasteDetail.vue?vue&type=template&id=bf885cce"
import script from "./ProductionWasteDetail.vue?vue&type=script&lang=js"
export * from "./ProductionWasteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports